import React from "react";
import classes from "./login.module.css";
import { Constants } from "../../Constants";
import { Carousel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OurCustomers from "./OurCustomers";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";


export const CarouselView = () => {
  return (
    <article
      className={`col-md-7 ${classes["carousel-background"]}`}
      style={{ fontSize: "13px" }}
    >
      <div
        style={{ backgroundColor: "#40398a", color: "#FFFFFF" }}
        className={`mb-2 ${classes["marquee"]}`}
      >
        <span>Multi-Million Business Opportunities from 120+ Companies!</span>
      </div>

      <div className="container" style={{ padding: "10px 0" }}>
        <Carousel
          indicators={true}
          className="login-carousel"
          prevIcon={<MdChevronLeft size={50} />}
          nextIcon={<MdChevronRight size={50} />}
        >
          {Constants.LoginCarouselItems.map((item, index) => {
            return (
              <Carousel.Item key={index} style={{ height: "260px" }}>
                <div className="p-4 text-center">
                  <div
                    style={{ fontSize: "60px", color: "#ffffff" }}
                  >
                    {item?.icon ? item?.icon : <></>}
                  </div>
                  <h1
                    className="h3"
                    style={{
                      fontWeight: 600,
                      color: "#ffffff",
                      marginBottom: "15px",
                      textTransform: "capitalize",
                    }}
                  >
                    {item.title}
                  </h1>
                  <p
                    className="text-light"
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1.6",
                      maxWidth: "620px",
                      margin: "0 auto",
                    }}
                  >
                    {item.description}
                  </p>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>

      <OurCustomers />
    </article>
  );
};

export const NotificationSlider = () => {
  const showNotificationMain = () => {
    if (window.screen.width > 600) {
      document.getElementById("NotificationMain-container").style.top = "0%";
      document.getElementById("NotificatiomSlider-container").style.top =
        "-20%";
    } else {
      document.getElementById("NotificationMain-container").style.top = "76%";
      document.getElementById("NotificatiomSlider-container").style.top =
        "150%";
    }
  };
  return (
    <div
      className={classes["NotificatiomSlider-container"]}
      id="NotificatiomSlider-container"
    >
      <div className={classes["content"]}>
        Are your trucks standing/stuck somewhere?{" "}
        <img
          alt="img"
          className={window.screen.width > 600 ? null : classes["arrow-down"]}
          onClick={showNotificationMain}
          src="https://img.icons8.com/android/24/000000/down.png"
        />
      </div>
    </div>
  );
};

export const NotificationMain = () => {
  return (
    <div
      className={classes["NotificationMain-container"]}
      id="NotificationMain-container"
    >
      <div className={classes["content"]}>
        Are your trucks standing/stuck somewhere waiting for return loads?
        Please call +91-8928008311 or 9833973964 or mail us to{" "}
        <a href="mailto:lorri@logisticsnow.in">lorri@logisticsnow.in</a>
      </div>
    </div>
  );
};
